import { PurchaseButtonLink } from "@/components/Buttons/index";
import FormatWatchPrice from "@/components/FormatWatchPrice";
import RightViewTerm from "@/components/RightViewTerm";
import { useAdultModeQuery, useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import routes from "@/lib/routes";
import styles from "@/styles/Video.module.scss";
import Image from "next/image";
import Link from "next/link";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ProductInfo(_ref) {
  var withLink = _ref.withLink,
      product = _ref.product,
      rights = _ref.rights,
      isLoggedIn = _ref.isLoggedIn;
  var right = useMemo(function () {
    if (!product.rightIds) return null;
    return rights.find(function (right) {
      return product.rightIds.includes(parseInt(right.id, 10));
    });
  }, [product, rights]);

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo;
  var discountPrice = right === null || right === void 0 ? void 0 : right.discount_price;
  var discountFlag = (right === null || right === void 0 ? void 0 : right.discount_price) > 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.product,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.productInner,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.image,
          children: product.thumbnailUrl && /*#__PURE__*/_jsx(Image, {
            src: product.thumbnailUrl,
            alt: product.name,
            width: 320,
            height: 180,
            layout: "responsive"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.info,
          children: [/*#__PURE__*/_jsx("h4", {
            className: styles.name,
            children: product.name
          }), /*#__PURE__*/_jsx("div", {
            className: styles.price,
            children: /*#__PURE__*/_jsx(FormatWatchPrice, {
              price: product.price,
              type: "tvod",
              isLoggedIn: isLoggedIn,
              discountPrice: discountPrice,
              discountFlag: discountFlag
            })
          }), /*#__PURE__*/_jsx("div", {
            className: styles.rightViewLimit,
            children: /*#__PURE__*/_jsx(RightViewTerm, {
              right: right
            })
          }), /*#__PURE__*/_jsx("div", {
            className: styles.description,
            children: product.description
          }), withLink && /*#__PURE__*/_jsx("div", {
            className: "".concat(styles.link, " ").concat(styles.isDesktop),
            children: /*#__PURE__*/_jsx(PurchaseButtonLink, {
              product: product,
              large: true
            })
          })]
        })]
      }), withLink && /*#__PURE__*/_jsx("div", {
        className: "".concat(styles.link, " ").concat(styles.isNotDesktop),
        children: /*#__PURE__*/_jsx(PurchaseButtonLink, {
          product: product
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.condition,
      children: [discountFlag && /*#__PURE__*/_jsxs(_Fragment, {
        children: ["\u203B\u653E\u9001\u5951\u7D04\u8005\u5411\u3051\u5272\u5F15\u63D0\u4F9B\u4FA1\u683C\u306F", /*#__PURE__*/_jsx(Link, {
          href: routes.campaignWithBroadcast,
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            children: "\u5272\u5F15\u5BFE\u8C61\u4E00\u89A7"
          })
        }), "\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u203B\u5272\u5F15\u9069\u7528\u4FA1\u683C\u3068\u306A\u308B\u5BFE\u8C61\u306E\u653E\u9001\u5951\u7D04\u89E3\u7D04\u5F8C\u306F\u901A\u5E38\u4FA1\u683C\u304C\u9069\u7528\u3055\u308C\u307E\u3059", /*#__PURE__*/_jsx("br", {})]
      }), "\u203B\u7279\u5B9A\u5546\u53D6\u5F15\u6CD5\u306B\u3064\u3044\u3066\u306F", /*#__PURE__*/_jsx(Link, {
        href: routes.legalSctLaw,
        children: /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          children: "\u3053\u3061\u3089"
        })
      }), "\u304B\u3089\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isAndroid) && /*#__PURE__*/_jsxs("span", {
        children: ["\u203BAndroid\u7AEF\u672B\u3092\u3054\u5229\u7528\u306E\u65B9\u306F\u30D6\u30E9\u30A6\u30B6\u4E0A\u3067\u306F\u3054\u8996\u8074\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3001\u5FC5\u305A", !adultMode && /*#__PURE__*/_jsx(Link, {
          href: config.appStoreUrl.android,
          children: "SPOOX\u30A2\u30D7\u30EA"
        }), adultMode && /*#__PURE__*/_jsx(Link, {
          href: config.firebaseDynamicLinks.adult.fallbackLink,
          children: "\u30E2\u30D0\u30A4\u30EB\u52D5\u753B\u30D7\u30EC\u30A4\u30E4\u30FC"
        }), "\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3054\u8996\u8074\u304F\u3060\u3055\u3044\u3002"]
      })]
    })]
  });
}